module.exports = __webpack_public_path__ + "assets/Upsilon.e975108e86588d84880c343c8285c6f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Upsilon.png
// module id = 801
// module chunks = 0